import React, { Dispatch, useEffect } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Action } from 'redux';

import lang from '../../lib/language';
import { IndividualExtendedInfoData } from '../../lib/models/enroll';
import { RootState } from '../../lib/store';
import { clearSignupToken as clearSignupTokenCall, getSignupToken as getSignupTokenCall } from '../../lib/store/auth';
import { checkIndividualActivationStep } from '../../lib/store/selectors';
import { isMyPortalTrade } from '../../lib/util/auth/helpers';

import useIsMobile from '../../hooks/useIsMobile';
import { UI_ROUTES } from '../../util/routes';

type OwnProps = {
  individual: IndividualExtendedInfoData;
  hasUserName: boolean;
  isPaymentsReady?: boolean;
};

type Props = OwnProps & ReduxProps;

const NotVerifiedNotification = (props: Props) => {
  const {
    individual,
    isFetchingPWPSignupURL,
    PWPSignupURL,
    accounts,
    account_id,
    getSignupToken,
    clearSignupToken,
    activationStep,
    hasUserName,
    transactions,
    isPaymentsReady,
  } = props;
  const history = useHistory();
  const isMobile = useIsMobile();

  const firstDescription = lang.activeYourAccountContent().slice(0, 66);
  const secondDescription = lang.activeYourAccountContent().slice(66);

  const fundsURL = isMyPortalTrade() ? UI_ROUTES.funds : `${UI_ROUTES.funds}${UI_ROUTES.makeYourFirstDeposit}`;

  useEffect(() => {
    if (!isFetchingPWPSignupURL && PWPSignupURL) {
      window.open(PWPSignupURL, isMobile ? '_self' : '_blank');
      clearSignupToken();// removing the signup token URL from the state to avoid the re-redirection on the next render time
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isFetchingPWPSignupURL, PWPSignupURL, isMobile]);

  const handleOnProceedClick = (): void => {
    if (isMyPortalTrade()) {
      history.push(UI_ROUTES.enroll);
      return;
    }

    if (isFetchingPWPSignupURL) {
      return;
    }
    getSignupToken();
  };

  const isMyPortalTradeAccountsCreated = () => isMyPortalTrade() && accounts.length > 0;

  return <></>;// No verfication steps in capital
};

const mapStateToProps = (state: RootState) => ({
  accounts: state.crm.accounts,
  activationStep: checkIndividualActivationStep(
    state.crm.individualExtendedInfo,
    state.crm.enroll.financialQuestionnaireSections,
    state.auth.isAppropriatenessPopupConfirmed,
  ),
  transactions: state.payment.paymentsAll.data,
  isFetchingPWPSignupURL: state.auth.isFetchingPWPSignupURL,
  account_id: state.crm.accountDetails.account_id,
  PWPSignupURL: state.auth.PWPSignupURL,
});

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
  getSignupToken: () => dispatch(getSignupTokenCall()),
  clearSignupToken: () => dispatch(clearSignupTokenCall()),
});

const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default connector(NotVerifiedNotification);
